import { action, makeObservable, observable } from "mobx";

class BetShopStore {
  betShopStatistic = null;
  isShowStatistic = false;

  constructor() {
    makeObservable(this, {
      betShopStatistic: observable,
      isShowStatistic: observable,
      setBetShopStatistic: action.bound,
      setIsShowStatistic: action.bound,
    });
  }

  setBetShopStatistic(statistic){
    this.betShopStatistic = statistic;
  }
  setIsShowStatistic(bool){
    this.isShowStatistic = bool;
  }

}

export const betShopStore = new BetShopStore();
